<template>
    <div v-if="showAccessModule" class="p-4 bg-light rounded shadow" style="margin-top: 75px; margin-left: 20px; margin-right: 20px;">
        <h3 class="text-center"><i class="bi bi-lock-fill"></i> You don't have access to this module</h3>
    </div>
</template>
<script>
export default {
    props: {
        showAccessModule: {
            type: Boolean,
            required: true,
        },
    }
};
</script>